import { render, staticRenderFns } from "./ApplicantProfileTabs.vue?vue&type=template&id=7f6a80a0"
import script from "./ApplicantProfileTabs.vue?vue&type=script&lang=js"
export * from "./ApplicantProfileTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports